export default __webpack_public_path__ + "static/media/HistoricAttach.77e9ba58.svg";